module.exports = __webpack_public_path__ + "img/logo.c3029a2f.png";